import { useRef, useCallback } from 'react';
const usePreviousQueryState = () => {
    const previousQueryStates = useRef({});
    const setPreviousQueryState = useCallback(function (queryKey, previousState) {
        const serializedQueryKey = JSON.stringify(queryKey);
        previousQueryStates.current = Object.assign(Object.assign({}, previousQueryStates.current), { [serializedQueryKey]: previousState });
        return previousState;
    }, []);
    const getPreviousQueryState = useCallback(function (queryKey) {
        const serializedQueryKey = JSON.stringify(queryKey);
        return previousQueryStates.current[serializedQueryKey];
    }, []);
    return { setPreviousQueryState, getPreviousQueryState };
};
export default usePreviousQueryState;
//# sourceMappingURL=usePreviousQueryState.js.map